import React from "react";

const EntriesDropdown = ({
  entriesPerPage,
  onEntriesChange,
  options = [10, 30, 50, 100, 200],
}) => {
  return (
    <label className="xc-entries">
      <span className="xc-entries__label">Show</span>
      <div className="dropdown">
        <button
          className="xc-entries__select"
          type="button"
          id="entriesDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {entriesPerPage}
          <i className="ri-arrow-down-s-line" aria-hidden="true" />
        </button>
        <ul className="dropdown-menu" aria-labelledby="entriesDropdown">
          {options.map((option) => (
            <li key={option}>
              <button
                type="button"
                className="dropdown-item"
                onClick={() => onEntriesChange(option)}
              >
                {option}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <span className="xc-entries__label">Entries</span>
    </label>
  );
};

export default EntriesDropdown;
